import { ColumnProps } from './interface';

export default {
  name: 'ATableColumn',
  props: ColumnProps,
};
